<template>
  <div class="register-form">
    <div class="title">注册{{ chooseNumber === 1 ? "企业" : "个人" }}账号</div>
    <div v-if="chooseNumber === 2">
      <el-form
        label-position="top"
        :model="personDataForm"
        :rules="dataRule"
        ref="personDataForm"
      >
        <el-form-item :label="$t('register.name')" prop="name">
          <el-input
            v-model="personDataForm.name"
            maxlength="40"
            auto-complete="new-password"
            :placeholder="$t('message.enter')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('register.inviteCode')" prop="invitationCode">
          <el-input
            v-model="personDataForm.invitationCode"
            maxlength="40"
            :placeholder="$t('message.enter')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('register.password')" prop="password">
          <el-input
            v-model="personDataForm.password"
            maxlength="40"
            type="password"
            auto-complete="new-password"
            :placeholder="$t('message.enter')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('register.passwordSure')" prop="rePassword">
          <el-input
            v-model="personDataForm.rePassword"
            maxlength="40"
            type="password"
            auto-complete="new-password"
            :placeholder="$t('message.enter')"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="chooseNumber === 1">
      <el-form
        label-position="top"
        :model="enterpriseDataForm"
        :rules="enterpriseDataRule"
        ref="enterpriseDataForm"
      >
        <el-form-item
          :label="$t('register.fullCompanyName')"
          prop="companyName"
        >
          <el-select
            class="w-full"
            v-model="enterpriseDataForm.companyName"
            filterable
            remote
            reserve-keyword
            placeholder="请输入企业名称"
            @change="onCompanyChange"
            :remote-method="companyRemoteMethod"
            :loading="companyLoading"
            style="width: 100%"
          >
            <el-option
              v-for="i in companyOptions"
              :key="i.value"
              :label="i.label"
              :value="i.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('register.socialCode')"
          prop="socialCreditCode"
        >
          <el-input
            v-model="enterpriseDataForm.socialCreditCode"
            maxlength="18"
            oninput="value=value.replace(/[^A-Za-z0-9]/g,'')"
            :placeholder="$t('message.enter')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('register.name')" prop="name">
          <el-input
            v-model="enterpriseDataForm.name"
            maxlength="40"
            :placeholder="$t('message.enter')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('register.inviteCode')" prop="invitationCode">
          <el-input
            v-model="enterpriseDataForm.invitationCode"
            maxlength="40"
            :placeholder="$t('message.enter')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('register.password')" prop="password">
          <el-input
            v-model="enterpriseDataForm.password"
            maxlength="40"
            type="password"
            auto-complete="new-password"
            :placeholder="$t('message.enter')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('register.passwordSure')" prop="rePassword">
          <el-input
            v-model="enterpriseDataForm.rePassword"
            maxlength="40"
            type="password"
            autocomplete="off"
            :placeholder="$t('message.enter')"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import { Base64 } from "js-base64";
import Cookies from "js-cookie";

export default {
  props: {
    chooseNumber: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      // 个人用户注册
      personDataForm: {
        userName: "", // 手机号
        name: "", // 用户名称
        password: "", // 登录密码
        invitationCode: "", // 邀请码
        appCode: window.SITE_CONFIG.appCode, // 应用编码
        clientId: "android",
        registerType: "", // 注册类型
        rePassword: "",
      },
      enterpriseDataForm: {
        username: "",
        name: "",
        companyName: "",
        password: "",
        rePassword: "",
        socialCreditCode: "",
        registerType: 2,
        invitationCode: "",
      },
      companyOptions: [],
      companyLoading: false,
      wxInfo: JSON.parse(sessionStorage.getItem("wxInfo") || "{}"),
      active: 0,
    };
  },
  computed: {
    enterpriseDataRule() {
      let validatePassword = (rule, value, callback) => {
        if (value && value !== this.enterpriseDataForm.password) {
          return callback(new Error(this.$t("forget.validatePassword")));
        }
        callback();
      };
      var validatePassword2 = (rule, value, callback) => {
        var myreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,30}$/;
        if (!myreg.test(value)) {
          callback(new Error(this.$t("forget.validatePassword2")));
        } else {
          callback();
        }
      };
      var validateCode = (rule, value, callback) => {
        if (value.length !== 15 && value.length !== 18) {
          callback(new Error("长度在 15 或者 18 个大小写字母或者数字"));
        } else {
          callback();
        }
      };
      return {
        name: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        socialCreditCode: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
          { required: true, validator: validateCode, trigger: "blur" },
        ],
        password: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
          { required: true, validator: validatePassword2, trigger: "blur" },
        ],
        rePassword: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
          { required: true, validator: validatePassword2, trigger: "blur" },
          { validator: validatePassword, trigger: "blur" },
        ],
      };
    },
    dataRule() {
      let validatePassword = (rule, value, callback) => {
        if (value && value !== this.personDataForm.password) {
          return callback(new Error(this.$t("forget.validatePassword")));
        }
        callback();
      };
      var validatePassword2 = (rule, value, callback) => {
        var myreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,30}$/;
        if (!myreg.test(value)) {
          callback(new Error(this.$t("forget.validatePassword2")));
        } else {
          callback();
        }
      };
      return {
        name: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
          { required: true, validator: validatePassword2, trigger: "blur" },
        ],
        rePassword: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
          { required: true, validator: validatePassword2, trigger: "blur" },
          { validator: validatePassword, trigger: "blur" },
        ],
      };
    },
  },
  mounted () {
    const mobile = Base64.decode(this.$route.query.mobile || '')
    this.personDataForm.mobile = mobile
    this.enterpriseDataForm.mobile = mobile
  },
  methods: {
    submitForm() {
      this.chooseNumber === 1
        ? this.enterpriseDataFormSubmitHandle()
        : this.personDataFormSubmitHandle();
    },
    // 个人注册
    personDataFormSubmitHandle: debounce(
      function () {
        this.$refs["personDataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          console.log("/front/consumer/user/register", {
            username: this.enterpriseDataForm.mobile,
            name: this.enterpriseDataForm.name,
            companyName: this.enterpriseDataForm.companyName,
            password: Base64.encode(this.enterpriseDataForm.password),
            socialCreditCode: this.enterpriseDataForm.socialCreditCode,
            registerType: 2,
            invitationCode: this.enterpriseDataForm.invitationCode,
            appCode: "PLANTMATE_OFFICIAL",
            clientId: "android",
            registByJoin: 0,
            usernameForValidate: Base64.decode(
              this.$route.query.usernameForValidate || ""
            ),
            openPlatformWebsiteAppOpenidCiphertext:
              this.wxInfo.openPlatformWebsiteAppOpenidCiphertext,
          });
          this.$http
            .post(`/front/consumer/user/register`, {
              username: this.personDataForm.mobile,
              name: this.personDataForm.name,
              companyName: "",
              password: Base64.encode(this.personDataForm.password),
              socialCreditCode: "",
              registerType: 1,
              invitationCode: this.personDataForm.invitationCode,
              appCode: "PLANTMATE_OFFICIAL",
              clientId: "android",
              usernameForValidate: Base64.decode(
                this.$route.query.usernameForValidate || ""
              ),
              openPlatformWebsiteAppOpenidCiphertext:
                this.wxInfo.openPlatformWebsiteAppOpenidCiphertext,
            })
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              } else {
                this.afterLogin(res);
                this.active = 3;
              }
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
    enterpriseDataFormSubmitHandle: debounce(
      function () {
        this.$refs["enterpriseDataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          let searchValue = this.enterpriseDataForm.socialCreditCode;
          let companyName = this.enterpriseDataForm.companyName;
          this.$http
            .get(`/front/cross/cust-company/check`, {
              params: {
                socialCreditCode: searchValue,
                companyName: companyName,
              },
            })
            .then(({ data: res }) => {
              if (res.data !== null) {
                this.$confirm(
                  this.$t("register.message1"),
                  this.$t("prompt.title"),
                  {
                    confirmButtonText: this.$t("login.applyJoin"),
                    cancelButtonText: this.$t("cancel"),
                    type: "warning",
                  }
                )
                  .then(() => {
                    this.$http
                      .post(`/front/consumer/user/register`, {
                        username: this.enterpriseDataForm.mobile,
                        name: this.enterpriseDataForm.name,
                        companyName: this.enterpriseDataForm.companyName,
                        password: Base64.encode(
                          this.enterpriseDataForm.password
                        ),
                        socialCreditCode:
                          this.enterpriseDataForm.socialCreditCode,
                        registerType: 2,
                        invitationCode: this.enterpriseDataForm.invitationCode,
                        appCode: "PLANTMATE_OFFICIAL",
                        clientId: "android",
                        registByJoin: 1,
                        usernameForValidate: Base64.decode(
                          this.$route.query.usernameForValidate || ""
                        ),
                        openPlatformWebsiteAppOpenidCiphertext:
                          this.wxInfo.openPlatformWebsiteAppOpenidCiphertext,
                      })
                      .then(({ data: res }) => {
                        if (res.code !== 0) {
                          return this.$message.error(res.msg);
                        } else {
                          this.afterLogin(res);
                          this.active = 4;
                        }
                      })
                      .catch(() => {});
                  })
                  .catch(() => {});
              } else {
                this.$http
                  .post(`/front/consumer/user/register`, {
                    username: this.enterpriseDataForm.mobile,
                    name: this.enterpriseDataForm.name,
                    companyName: this.enterpriseDataForm.companyName,
                    password: Base64.encode(this.enterpriseDataForm.password),
                    socialCreditCode: this.enterpriseDataForm.socialCreditCode,
                    registerType: 2,
                    invitationCode: this.enterpriseDataForm.invitationCode,
                    appCode: "PLANTMATE_OFFICIAL",
                    clientId: "android",
                    registByJoin: 0,
                    usernameForValidate: Base64.decode(
                      this.$route.query.usernameForValidate || ""
                    ),
                    openPlatformWebsiteAppOpenidCiphertext:
                      this.wxInfo.openPlatformWebsiteAppOpenidCiphertext,
                  })
                  .then(({ data: res }) => {
                    if (res.code !== 0) {
                      return this.$message.error(res.msg);
                    } else {
                      this.afterLogin(res);
                      this.active = 3;
                    }
                  })
                  .catch(() => {});
              }
            });
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
    afterLogin(res) {
      console.log("afterLogin", res);
      Cookies.set("access_token_shop", res.data.access_token);
      // 学习平台cookie登录共享
      Cookies.set("access_token_shop", res.data.access_token, {
        domain: location.origin.includes("plantmate.supcon.com")
          ? ".supcon.com"
          : ".plantmate.com",
      });
      window.SITE_CONFIG["permissions"] = res.data.permissions || [];
      // 通知外部登录成功
      this.$emit('next', this.active)
    },
    onCompanyChange(res) {
      const val = (this.companyOptions || []).find(
        (i) => i.companyName === res
      );
      this.enterpriseDataForm.socialCreditCode = val.socialCreditCode;
    },
    companyRemoteMethod(str) {
      if (!str) return;
      this.companyLoading = true;
      this.$http
        .get(
          `/inter/qixinbao/fuzzyQueryByKeyword?keyword=${str}&matchType=ename&region=&skip=`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.companyOptions = res.data.map((item) => {
              return {
                ...item,
                label: item.companyName,
                value: item.companyName,
              };
            });
          }
        })
        .finally(() => {
          this.companyLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.register-form {
  padding: 24px;
  .title {
    font-size: 28px;
    color: #3d3d3d;
  }
  ::v-deep .el-form {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  ::v-deep .el-form-item {
    width: 48%;
  }
  ::v-deep .el-form-item__label {
    font-size: 16px;
    color: #3d3d3d;
    padding: 0;
  }
}
</style>
